import {
  ProjectTags2Document,
  type ProjectTags2Query,
} from '../../generated/graphql';
import {makeInfiniteSelectField} from './InfiniteSelectField';

/**
 * Tag field for a run filter row on a tag key, backed by `project.runTags`.
 */
export const FilterTagSelectField = makeInfiniteSelectField<ProjectTags2Query>({
  label: 'Tag',
  placeholder: 'Select a tag',
  searchPlaceholder: 'Search tags',
  extractItems: data =>
    data?.project?.runTags?.edges.map(edge => edge.node.name) ?? [],
  extractPageInfo: data => data?.project?.runTags?.pageInfo ?? {},
  query: ProjectTags2Document,
});
